module.exports = __webpack_public_path__ + "static/media/KUDOS AUDIO SIGAO DRIVE.c531ceb6.png";